"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const DateField_1 = __importDefault(require("components/QuickenControls/DateField"));
const utils_1 = require("data/transactions/utils");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const PosedOnField = ({ attributes, forceStatic, editable, SHOW_ALL, txn, noDateOnBankPending, editClass, hoverClass, currEditFieldName, enableAutoFocus, showColor, bankPendingClass, callbacks, }) => {
    var _a;
    const { classes, theme } = useStyles();
    const isPending = ((0, utils_1.isPendingTxn)(txn) && noDateOnBankPending) && !(0, utils_1.isUnacceptedScheduledTxn)(txn);
    const cname = (0, classnames_1.default)(classes.regItem, editClass, !isPending && hoverClass, 'protectWidthDate');
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    return (<styles_1.RegListItem {...attributes} className={cname}>
      {SHOW_ALL && (<DateField_1.default disableKeyboardInput={false} fieldId="postedOn" editable={!forceStatic && editable && currEditFieldName === 'postedOn'} value={txn.postedOn} onChange={(e) => { var _a; return (_a = callbacks.handleChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, 'postedOn'); }} 
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        fontSize={(_a = theme.mixins) === null || _a === void 0 ? void 0 : _a.register.fontSize.default} autoFocus={enableAutoFocus} clickable={!forceStatic ? 'true' : null} className={(0, classnames_1.default)(classes.dateField, ...(isPending && showColor ? [classes.pending] : []), bankPendingClass, c2RTxnClass)} changeDateOnKeyDown/>)}
    </styles_1.RegListItem>);
};
exports.default = PosedOnField;
